<template>
  <div>
    <tile-grid v-if="numberOfWidgets > 0">
      <widget-tile v-if="usesEenergoWidget" class="grid-widget" />
      <service-tile
        v-for="service in getFavoriteServices"
        :key="service.id"
        :service="service"
        :selected="false"
        :icon="service.icon" />
    </tile-grid>
    <p v-else>
      <strong>{{ $t('nothing-is-here') }}</strong>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ServiceTile from '@/components/services/service/ServiceTile';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import TileGrid from '@/components/utils/TileGrid';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import WidgetTile from '@/components/utils/tiles/WidgetTile';

export default {
  name: 'Dashboard',
  mixins: [
    BreadcrumbsManager,
  ],
  computed: {
    ...mapGetters([
      'getFavoriteServices',
    ]),
    ...mapGetters('user', [
      'getUserData',
    ]),
    numberOfWidgets() {
      return this.getFavoriteServices.length + this.usesEenergoWidget;
    },
    usesEenergoWidget() {
      return (this.getUserData.extra_settings || {}).useEnergoWidget || false;
    },
    breadcrumbs() {
      return [
        {
          text: 'Oblíbené',
          to: {
            name: 'dashboard',
          },
        },
      ];
    },
  },
  methods: {
    widgetClicked() {
      console.log('clicked', this.showWidget);
      this.showWidget = !this.showWidget;
    },
  },
  components: {
    TileGrid,
    ServiceTile,
    WidgetTile,
  },
  created() {
    eventBus.$on('widgetClicked', this.widgetClicked);
  },
  destroyed() {
    eventBus.$off('widgetClicked');
  },
};
</script>

<style scoped lang="scss">
</style>
